import _extends from "@babel/runtime/helpers/extends";
import { Box, CustomModalLayout } from '@wix/design-system';
import React from 'react';
import { PlanFeatures } from '../PlanFeatures';
export const PlanFeaturesModalContent = _ref => {
  let {
    productId,
    t,
    Trans,
    header,
    footer,
    primaryButtonText,
    paymentCycle,
    isDetailedView,
    onClose,
    onError,
    primaryButtonOnClick,
    maxHeight,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(CustomModalLayout, _extends({}, props, {
    maxHeight: maxHeight ?? '700px',
    onCloseButtonClick: onClose,
    primaryButtonText: primaryButtonText ?? t('change_plan.current_plan_modal.close'),
    primaryButtonOnClick: primaryButtonOnClick ?? onClose
  }), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical"
  }, header, /*#__PURE__*/React.createElement(PlanFeatures, {
    productId: productId,
    paymentCycle: paymentCycle,
    isDetailedView: isDetailedView,
    t: t,
    Trans: Trans,
    onError: onError
  }), footer));
};
//# sourceMappingURL=PlanFeaturesModalContent.js.map